export const ON_FOUNDATION_IS_OPEN = 'ON_FOUNDATION_IS_OPEN';

export function onFoundationsOpen(isOpen) {
  return {
    type: ON_FOUNDATION_IS_OPEN,
    payload: {'data': isOpen},
  };
}



// WEBPACK FOOTER //
// ./app/features/layout/actions/onFoundationIsOpen.js